/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_Ref_H1Inputs */

const en_to_xml_ref_h1 = /** @type {(inputs: To_Xml_Ref_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON`)
};

const ko_to_xml_ref_h1 = /** @type {(inputs: To_Xml_Ref_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON`)
};

const ja_to_xml_ref_h1 = /** @type {(inputs: To_Xml_Ref_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON`)
};

/**
* | output |
* | --- |
* | "JSON" |
*
* @param {To_Xml_Ref_H1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_ref_h1 = /** @type {((inputs?: To_Xml_Ref_H1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_Ref_H1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_ref_h1(inputs)
	if (locale === "ko") return ko_to_xml_ref_h1(inputs)
	return ja_to_xml_ref_h1(inputs)
});